import { ReactNode } from 'react';
import AppShell from '@components/layout/app-shell/app-shell.tsx';
import SideNavBackOffice from '@components/layout/sidebar/side-nav-back-office.tsx';
import ResponsiveSideNavBackOffice from '@components/layout/responsive-side-nav-back-office.tsx';

interface Props {
  layoutType?: 'main' | 'editor';
  children: ReactNode;
  disableOverflowY?: boolean;
}

export default function BackOfficeWrapper(props: Props) {
  return (
    <AppShell
      sidebar={<SideNavBackOffice />}
      mobileSidebar={(open, setOpen) => (
        <ResponsiveSideNavBackOffice
          sidebarOpen={open}
          setSidebarOpen={setOpen}
        />
      )}
      layoutType={props.layoutType}
      disableOverflowY={props.disableOverflowY}
    >
      {props.children}
    </AppShell>
  );
}
